(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  $('.remove-bundle-item-btn').click(function(){
    const updates = {}
    $('.remove-bundle-item-btn').each((indx, item) => {
      const productKey = $(item).data('product-key')
      updates[productKey] = 0
    })
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
      updates: updates
    }, function() {
      window.location.reload();
    })
  })

  } catch(e) { console.error(e); }
})();
})();
